import React, { useCallback } from 'react';
import { Axis } from '@visx/axis';
import { Text } from '@visx/text';
import { useTooltip, useTooltipInPortal } from '@visx/tooltip';
import { GridColumns } from '@visx/grid';
import { tooltipStyles } from './HorizontalBarChart.styles';
/**
 * Provides left axis and vertical lines for the `HorizontalBarChart` component.
 */
export function MeasurementRows({ axisProps, color, data, tickProps, verticalLinesToShow, xScale, yAxisKey, yMax, yScale, }) {
    const { containerBounds, TooltipInPortal } = useTooltipInPortal();
    const { showTooltip, hideTooltip, tooltipData, tooltipLeft = 0, tooltipTop = 0 } = useTooltip();
    // https://airbnb.io/visx/tooltip
    const handlePointerMove = useCallback((event, value) => {
        const containerX = ('clientX' in event ? event.clientX : 0) - containerBounds.left;
        const containerY = ('clientY' in event ? event.clientY : 0) - containerBounds.top;
        showTooltip({
            tooltipLeft: containerX,
            tooltipTop: containerY - 10,
            tooltipData: value,
        });
    }, [showTooltip, containerBounds]);
    const customTick = (formattedValue = '', x, y) => {
        const { className } = data.find((datum) => datum[yAxisKey] === formattedValue);
        const maxChars = 20;
        const trimmedValue = formattedValue.length <= maxChars
            ? formattedValue
            : formattedValue.substr(0, maxChars).concat('...');
        return (React.createElement(Text, Object.assign({}, tickProps, { className: className || '', x: x, y: y, dx: '-0.65em', dy: -1, textAnchor: "end", verticalAnchor: "middle", onPointerMove: (e) => handlePointerMove(e, formattedValue), onPointerLeave: () => hideTooltip() }), trimmedValue));
    };
    const tickLength = 7;
    return (React.createElement("g", { style: { color } },
        React.createElement("line", Object.assign({ x1: 0, y1: 1, x2: -tickLength, y2: 1 }, axisProps)),
        React.createElement("line", Object.assign({ x1: 0, y1: yMax, x2: -tickLength, y2: yMax }, axisProps)),
        React.createElement(TooltipInPortal, { style: tooltipStyles, left: tooltipLeft, top: tooltipTop },
            React.createElement("div", { className: "tooltip" }, tooltipData)),
        React.createElement(Axis, Object.assign({}, axisProps, { axisClassName: "left-axis-container", orientation: "left", left: 0, scale: yScale, numTicks: data.length, tickLength: tickLength, tickStroke: "currentColor", tickComponent: (tickValues) => customTick(tickValues.formattedValue, tickValues.x, tickValues.y) })),
        React.createElement(GridColumns, { scale: xScale, height: yMax, numTicks: verticalLinesToShow, stroke: "currentColor", strokeOpacity: 0.4, pointerEvents: "none" })));
}
//# sourceMappingURL=MeasurementRows.js.map